import { useState, useRef } from "react";
import EditIcon from "../../../ui/EditIcon";
import { Table, Typography } from "antd";

import ServiceForm from "./ServiceForm";
import { formatToINR } from "../../../../helpers/utility";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import { getTablePagination } from "../../../../utils/tablePagination";
import useIsMobile from "../../../../hooks/useIsMobile";
import usePageFillTableScroll from "../../../../hooks/usePageFillTableScroll";
import styles from "../Services.module.css";

const { Paragraph } = Typography;

const ServiceTable = ({
  data,
  refreshPage,
  userDetails,
  loading,
  page,
  setPage,
  totalCount,
}) => {
  const isMobile = useIsMobile();
  const tableWrapRef = useRef(null);
  const tableScroll = usePageFillTableScroll(
    tableWrapRef,
    isMobile,
    "default",
    Array.isArray(data) ? data.length : 0
  );
  const [isVisible, setIsVisible] = useState(false);
  const [editListData, setEditListData] = useState(null);

  const defaultRole = userDetails?.currRole || getCookie(Role);
  const columns = [
    {
      title: "Service Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => {
        const descA = a?.description || "";
        const descB = b?.description || "";
        return descA?.localeCompare(descB);
      },
      render: (value) => (
        <Paragraph
          ellipsis={{
            rows: 2,
            expandable: true,
            symbol: "more",
          }}
          // style={{ width: 320 }}
        >
          {value}
        </Paragraph>
      ),
    },
    {
      title: "Category",
      dataIndex: ["category", "name"],
      key: "category",
      width: isMobile ? 120 : undefined,
      ellipsis: isMobile,
      sorter: (a, b) => a?.category?.name?.localeCompare(b?.category?.name),
    },
    {
      title: "Cash Price (Including tax)",
      dataIndex: "cash_price",
      key: "cash_price",
      width: isMobile ? 130 : undefined,
      sorter: (a, b) => a?.cash_price - b?.cash_price,
      render: (value) => (value ? formatToINR(value) : "-"),
    },
    {
      title: "Insurance Price (Including tax)",
      dataIndex: "insurance_price",
      key: "insurance_price",
      width: isMobile ? 140 : undefined,
      sorter: (a, b) => a?.insurance_price - b?.insurance_price,
      render: (value) => (value ? formatToINR(value) : "-"),
    },
    ...(defaultRole === "Receptionist" || defaultRole === "Facility_Admin"
      ? []
      : [
          {
            title: "Action",
            render: (_, record) => (
              <EditIcon
                onClick={() => {
                  setIsVisible(true);
                  setEditListData(record);
                }}
              />
            ),
          },
        ]),
  ];
  return (
    <div ref={tableWrapRef} className={`${styles.servicesTableWrap} ui-table-fill-body`}>
      <Table
        className="no-vertical-borders"
        columns={columns}
        dataSource={data}
        pagination={getTablePagination({
          current: page,
          pageSize: 100,
          total: totalCount ?? 0,
          onChange: (p) => setPage(p),
        })}
        scroll={tableScroll}
        loading={loading}
      />
      {isVisible && (
        <ServiceForm
          open={isVisible}
          setOpen={setIsVisible}
          refreshPage={refreshPage}
          editListData={editListData}
        />
      )}
    </div>
  );
};

export default ServiceTable;
